export default __webpack_public_path__ + "static/assets/53f036b94c09775819ffb33a1026546c.png";